export const SUMMIT = { id: 'summit', label: 'Vertice' };
export const PODEX = { id: 'podex', label: 'Podice' };
export const FRONT = { id: 'front', label: 'Fronte' };
export const BREGMA = { id: 'bregma', label: 'Bregma' };
export const FACE = { id: 'face', label: 'Faccia' };
export const SHOULDER = { id: 'shoulder', label: 'Spalla' };
